import { AlertCircle, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import type { ClipSourceStatus } from '@/lib/clips/sourceReadiness';

export function ClipSourceNotice({ status }: { status: ClipSourceStatus }) {
  const { t } = useTranslation();
  if (status === 'ready') return null;
  const preparing = status === 'preparing';
  const Icon = preparing ? Loader2 : AlertCircle;
  return (
    <Alert variant={preparing ? 'default' : 'destructive'} className="mb-6" role={preparing ? 'status' : 'alert'}>
      <Icon className={preparing ? 'h-4 w-4 animate-spin' : 'h-4 w-4'} />
      <AlertTitle>{t(`projectClips.source.${status}.title`)}</AlertTitle>
      <AlertDescription>{t(`projectClips.source.${status}.description`)}</AlertDescription>
    </Alert>
  );
}
